import { type bookingsChartQuery } from "./index";
import { type VariablesOf } from "@/graphql";

// Define the interval types for chart display
export type IntervalType = "days" | "weeks" | "months";

// Default configuration for the chart intervals
export const DEFAULT_INTERVAL_CONFIG = {
  bucketCount: {
    days: 7, // Show 1 week worth of days
    weeks: 4, // Show 4 weeks (current behavior)
    months: 3, // Show 3 months initially
  },
  defaultInterval: "weeks" satisfies IntervalType,
} as const;

// Define which booking statuses to include in chart queries (excludes CANCELLED)
export const CHART_BOOKING_STATUSES = [
  "PLANNED",
  "DRAFT",
  "BOOKED",
  "SHIPPED",
  "AWAITING_PAYMENT",
  "PAID",
  "ARCHIVED",
  "CLOSED",
] as const satisfies NonNullable<VariablesOf<typeof bookingsChartQuery>["status"]>;
